import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { TitleLabel, containerStyle } from './Title';
import TitleArrow from './TitleArrow';
var DraggableTitle = function DraggableTitle(props) {
  var index = props.index,
    styles = props.styles,
    updateOrder = props.updateOrder,
    moveColumn = props.moveColumn,
    width = props.width,
    htmlTable = props.htmlTable,
    headerStyle = props.headerStyle,
    key = props.columnKey;
  var ref = useRef(null);
  var _useDrop = useDrop({
      accept: 'ui-title',
      hover: function hover(item, monitor) {
        if (index === item.index) {
          return;
        }
        moveColumn(item.index, index);
        item.index = index;
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    drop = _useDrop2[1];
  var _useDrag = useDrag({
      item: {
        type: 'ui-title',
        key: key,
        index: index
      },
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      }
    }),
    _useDrag2 = _slicedToArray(_useDrag, 2),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1];
  drag(drop(ref));
  var style = containerStyle(styles, width, headerStyle);
  var updateOrderWeb = function updateOrderWeb(key, e) {
    updateOrder(key, e.shiftKey || e.metaKey);
  };
  if (htmlTable) {
    return /*#__PURE__*/React.createElement("th", {
      ref: ref,
      style: style,
      onClick: function onClick(e) {
        return updateOrderWeb(key, e);
      }
    }, /*#__PURE__*/React.createElement(TitleLabel, props), /*#__PURE__*/React.createElement(TitleArrow, props));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      style: style,
      onClick: function onClick() {
        return updateOrderWeb(key, e);
      }
    }, /*#__PURE__*/React.createElement(TitleLabel, props), /*#__PURE__*/React.createElement(TitleArrow, props));
  }
};
export default DraggableTitle;